import { mlyApi, getHeaders } from "config/mlyApi";
export async function getCategories() {
  const requestConfig = await getHeaders();
  const url = `/categories`;
  return mlyApi.get<any>(url, requestConfig);
}
